import { initIkasProductImage } from "../image/init";
import { initIkasProductAttributeValue } from "../attribute-value/init";
import _sortBy from "lodash/sortBy";
import { IkasProductVariant } from ".";

export function initIkasProductVariant(variant: IkasProductVariant) {
  variant.images?.forEach(initIkasProductImage);
  variant.images = _sortBy(variant.images, "order");
  variant.attributes.forEach(initIkasProductAttributeValue);
}
